export default __webpack_public_path__ + "static/media/moira.76448291.webp";